"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YYYY_MM_DD = void 0;
exports.createDay = createDay;
exports.createMonth = createMonth;
exports.createWeek = createWeek;
exports.getDateType = getDateType;
exports.getDaysAfterMonth = getDaysAfterMonth;
exports.getDaysBeforeMonth = getDaysBeforeMonth;
exports.getDefaultState = getDefaultState;
exports.getLocaleValue = getLocaleValue;
exports.getPlaceInRange = getPlaceInRange;
exports.isDayChosen = isDayChosen;
exports.isDayDisabled = isDayDisabled;
exports.isDayHovered = isDayHovered;
exports.isInRange = isInRange;
exports.isToday = isToday;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _localeLanguageDays = require("./localeLanguageDays");
const YYYY_MM_DD = exports.YYYY_MM_DD = "YYYY-MM-DD";
function getLocaleValue(lang) {
  let code = lang;
  if (lang === _localeLanguageDays.userLanguages.zh) code = "zh-cn";else if (lang === _localeLanguageDays.userLanguages.tl) code = "tl-ph";
  return code;
}
function createDay(date, state) {
  const result = {
    date,
    isChosen: isDayChosen(date, state),
    isDisabled: isDayDisabled(date, state),
    isHovered: isDayHovered(date, state),
    isInRange: isInRange(date, state),
    isToday: isToday(date),
    placeInRange: getPlaceInRange(date, state),
    type: getDateType(date, state)
  };
  return result;
}
function createMonth(focusDate, state) {
  const monthState = {
    ...state,
    focusDate
  };
  const monthStart = (0, _dayjs.default)(focusDate).startOf("month");
  const monthEnd = (0, _dayjs.default)(focusDate).endOf("month");
  const daysBefore = getDaysBeforeMonth(monthStart);
  const daysAfter = getDaysAfterMonth(monthEnd);
  const daysInMonth = focusDate.daysInMonth();
  const daysOnCalendar = daysBefore + daysInMonth + daysAfter;
  const firstDayOnCalendar = (0, _dayjs.default)(monthStart).subtract(daysBefore, "days");
  let firstDayOfWeek = firstDayOnCalendar;
  let result = [];
  for (let i = 0; i < daysOnCalendar / 7; i++) {
    result[i] = createWeek(firstDayOfWeek, monthState);
    firstDayOfWeek = (0, _dayjs.default)(firstDayOfWeek).add(7, "days");
  }
  return result;
}
function createWeek(firstDayOfWeek, state) {
  let result = [];
  let currentDay = firstDayOfWeek;
  for (let i = 0; i < 7; i++) {
    result[i] = createDay(currentDay, state);
    currentDay = (0, _dayjs.default)(currentDay).add(1, "day");
  }
  return result;
}
function getDateType(date, state) {
  if (state.focusDate.format("MM") !== date.format("MM")) {
    return "padding-day";
  }
  return "day";
}
function getDaysBeforeMonth(firstDayOfMonth) {
  const result = firstDayOfMonth.day();
  return result;
}
function getDefaultState() {
  return {
    datesChosen: [(0, _dayjs.default)(), (0, _dayjs.default)().add(1, "day")],
    focusDate: (0, _dayjs.default)()
  };
}
function getDaysAfterMonth(lastDayOfMonth) {
  // remember, .day() works with zero-based values
  return 6 - lastDayOfMonth.day();
}
function getPlaceInRange(date, state) {
  const {
    datesChosen,
    dateHovered,
    isRange
  } = state;
  if (!isRange) {
    return "not a range date picker";
  }

  // out of range
  if (!isInRange(date, state)) {
    return "out of range";
  }

  // in range, beginning
  if (datesChosen[0] && date.format(YYYY_MM_DD) === datesChosen[0].format(YYYY_MM_DD)) {
    return "beginning";
  }

  // in range, end
  if (Boolean(datesChosen[1])) {
    if (date.format(YYYY_MM_DD) === datesChosen[1].format(YYYY_MM_DD)) {
      return "end";
    }
  }
  if (dateHovered && datesChosen.length === 1) {
    if (date.format(YYYY_MM_DD) === dateHovered.format(YYYY_MM_DD)) {
      return "end";
    }
  }
  return "middle";
}
function isDayChosen(date, state) {
  const {
    datesChosen
  } = state;
  if (datesChosen[0] && datesChosen[0].format(YYYY_MM_DD) === date.format(YYYY_MM_DD)) {
    return true;
  } else if (datesChosen[1] && datesChosen[1].format(YYYY_MM_DD) === date.format(YYYY_MM_DD)) {
    return true;
  }
  return false;
}
function isDayHovered(date, state) {
  const {
    dateHovered
  } = state;
  if (!dateHovered) {
    return false;
  }
  return dateHovered.format(YYYY_MM_DD) === date.format(YYYY_MM_DD);
}
function isDayDisabled(date, state) {
  const {
    datesChosen,
    isRange,
    daysInRange,
    minDate,
    maxDate,
    blackoutDates
  } = state;
  const startOfRange = isRange && datesChosen[0] ? datesChosen[0] : false;
  const maxOfRange = startOfRange && !datesChosen[1] ? startOfRange.add(daysInRange, "days") : false;
  const min = minDate || (0, _dayjs.default)();
  const max = maxOfRange || maxDate || (0, _dayjs.default)().add(1, "years");
  const minFormatted = min.format(YYYY_MM_DD);
  const maxFormatted = max.format(YYYY_MM_DD);
  const dateFormatted = date.format(YYYY_MM_DD);
  if (blackoutDates) {
    for (let bdate of blackoutDates) {
      if (dateFormatted === bdate.format(YYYY_MM_DD)) {
        return true;
      }
    }
  }
  if (dateFormatted === minFormatted || dateFormatted === maxFormatted) {
    return false;
  }
  if (min.unix() <= date.unix() && date.unix() <= max.unix()) {
    return false;
  }
  return true;
}
function isInRange(date, state) {
  const {
    datesChosen,
    dateHovered
  } = state;
  // expecting datesChosen and dateHovered in state
  // this assumes datesChosen are ordered

  // handling chosen dates
  if (datesChosen.length === 2) {
    if (isDayChosen(date, state)) {
      // is one of the chosen dates
      return true;
    } else if (datesChosen[0] && date.unix() > datesChosen[0].unix() && datesChosen[1] && date.unix() < datesChosen[1].unix()) {
      // this is between the chosen dates
      return true;
    }
  }

  // handling hover, if 1 date is chosen and hovered date is >= only date chosen
  if (datesChosen.length === 1 && dateHovered && Boolean(datesChosen[0]) && dateHovered.unix() >= datesChosen[0].unix()) {
    if (datesChosen[0] && datesChosen[0].format(YYYY_MM_DD) === date.format(YYYY_MM_DD) || dateHovered.format(YYYY_MM_DD) === date.format(YYYY_MM_DD)) {
      // is the chosen date or hovered date
      return true;
    } else if (datesChosen[0] < date && dateHovered > date) {
      // is between chosen and hovered dates
      return true;
    }
  }
  return false;
}
function isToday(date) {
  const todayFormatted = (0, _dayjs.default)().format(YYYY_MM_DD);
  const dateFormatted = date.format(YYYY_MM_DD);
  return todayFormatted === dateFormatted;
}